var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_61_50)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.1736 4.6875C30.6771 4.6875 34.375 9.92578 34.375 14.8125C34.375 24.709 19.0278 33.5 18.75 33.5C18.4722 33.5 3.125 24.709 3.125 14.8125C3.125 9.92578 6.82292 4.6875 12.3264 4.6875C15.4861 4.6875 17.5521 7.09375 18.75 8.5C19.9479 7.09375 22.0139 4.6875 25.1736 4.6875Z",
    stroke: "#8A96A3",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_61_50"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartIcon);
export default __webpack_public_path__ + "static/media/heart_icon.7823d4e36ec784448009fc870825fea2.svg";
export { ForwardRef as ReactComponent };